





























import { computed, defineComponent } from '@vue/composition-api';

import useDeliveryAreaCode from '@/useDeliveryAreaCode';

import getAllAreaCodes from '@/gql/areaCode/getAllAreaCodes.gql';

const CommonAreaCodeSelector = defineComponent({
  props: {
    label: {
      type: String,
      default() { return 'พื้นที่จัดส่ง'; },
    },
    value: {},
    level: {},
    showLabel: { default: false },
    rules: { default: '' },
    multiple: { default: false },
    optionLabel: {},
    small: { default: false },
    limit: { default: 6 },
  },
  setup(props: any) {
    const { translateDistanceType } = useDeliveryAreaCode();

    const _value = computed(() => props.value);

    return {
      _value,

      getAllAreaCodes,
      result: (data: any) => data.areas,
      customLabel: (obj: any) => `[${obj.code}] ${obj.name} *${translateDistanceType(obj.distanceType)}`,
    };
  },
});

export default CommonAreaCodeSelector;
